function formateDate(data) {
	let dia = data.getDate();
	let mes = data.getMonth() + 1;
	let ano = data.getFullYear();
	dia = dia < 10 ? '0' + dia : dia;
	mes = mes < 10 ? '0' + mes : mes;
	return ano + '-' + mes + '-' + dia;
}
